import { ProposalDeliverable } from '@teem/models/proposal-deliverable';
import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';
import * as moment from 'moment';


export class ProposalSerializer implements Serializer {
  fromJson(json: any): Proposal {
    let invoice = new Proposal(json);
    return invoice;
  }

  toJson(invoice: Proposal): any {
  	return invoice;
  }
} 

export class Proposal implements Resource {
	public uuid: string;
	public title: string = '';
	public description: string = '';
	public proposal_number: string = null;
	public total_amount: number = 0;
	public sub_total: number = 0;
	public client_id: number = null;
	public comments: string = ''; 
	public deliverables: ProposalDeliverable[];
	public terms: any;
	public is_draft: 0 | 1 = 0;
	public action: string;
	public links: Array<string>;
	public attachments: Array<any>;
	public client_name: string;
	public client_email: string;
	public quote_date:string = moment().format('YYYY-MM-DD');
	public project_type: string = 'fixed';
	public tax_rate: number;
	public payment_info: any;
	public save_default_payment_info: boolean = false;
	public files: any;

	constructor(input?: any) {
		if(input) {
			Object.assign(this, input);

			if(input.deliverables && input.deliverables.length){
				this.deliverables = [];
				input.deliverables.forEach(item => {
					this.deliverables.push(new ProposalDeliverable(item))
				});
			}

			if(input.sub_total) {
				if(input.tax_rate) {
					this.total_amount = this.sub_total / (1 + this.tax_rate/100);
				} else {
					this.total_amount = this.sub_total;
				}
			}
		}
	}
}
